import * as React from 'react';
import styles from './StickyHeader.scss';
import {IOuter} from './StickyHeader.types';

export const StickyHeader: React.FunctionComponent<IOuter> = ({children}) => {
  return <div className={styles.stickyHeader}>{children}</div>;
};

StickyHeader.displayName = 'StickyHeader';
